import router from '@/router';
import axios from 'axios'
import api from '@/api'
import store from '@/store'

export const loginModule = {
    namespaced: true,

    state:() => ({
        verInputCode: false,
        token: null,
        error: null,
    }),

    mutations: {
        setVerCode(state, bool) {
            state.verInputCode = bool
        },

        setToken(state, token) {
            state.token = token
        },

        setError(state, string) {
            state.error = string
        }
    },

    actions: {
        setNumberPhone({ commit, dispatch }, data) {
            axios
            .post(api + "projects/tcode/auth/phone/", {
                phone: data.phone,
                password: data.password
            })
            .then((response) => {
                if(response.status == 200) {
                    commit('setToken', response.data.token)
                
                    dispatch('userAuth', data.modal ? data.modal : null)
                }
            })
            .catch((error) => {
                console.log(error);
                const message =
                    error.response?.data?.error ||
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.message ||
                    "Ошибка авторизации";

                if(message == 'Invalid password') {
                    commit('setError', 'Неправильный логин или пароль');
                } else {
                    commit('setError', message);
                }
            });
        },

        // validateCode({ commit, dispatch }, data) {
        //     const validPhone = data.phone.replace(/\s+/g, '').slice(1)
        //     axios
        //     .post(api + "projects/tcode/auth/verification/", {
        //         phone: validPhone,
        //         code: data.code,
        //     })
        //     .then((response) => {
        //         commit('setToken', response.data.token)
                
        //         dispatch('userAuth', data.modal ? data.modal : null)
        //     })
        //     .catch((error) => {
        //         commit('setVerCode', true)
        //     });
        // },

        async userAuth({ state }, modal) {
            try {
                const response = await axios.get(api + "projects/tcode/profile/", {
                    headers: {
                        Authorization: 'Token ' + state.token
                    }
                })

                localStorage.setItem('token', state.token);
                store.dispatch('getProfileData')
                if(!modal) {
                    router.replace({ path: '/' })
                }
            } catch(err) { // Если есть ошибка
                console.log(err);
            }
        },
    }
}